export default __webpack_public_path__ + "static/media/Photonic-300w-min.3be4a477.jpeg";